<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .cons{
    display: none;
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-between;
    flex-wrap: wrap;
    li{
      width: 190px;
      height: 188px;
      //margin-right:60px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .service{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/合成基因组学产品及服务/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .required{
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  //.effect-lists li{
  //  margin-right: 12px;
  //  float: left;
  //}
  //.effect-lists li:last-child{
  //  margin-right: 0;
  //}
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/合成基因组学产品及服务/bg1.png") no-repeat;
    background-size: 100% 100%;
  }
  .xing_1{
    display: flex;
    overflow: auto;
    justify-content: space-between;
    flex-wrap: wrap;
    li{
      height: 312px;
      width: 380px;
      //margin-right: 30px;
      .img{
        width: 123px;
        padding-top: 43px;
        padding-bottom: 45px;
        margin-left: auto;
        margin-right: auto;
      }
      p{
        font-size: 20px;
        color:#fff;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
    }
    li:last-child{
      margin-right: 0;
    }
    .xingcheng1{
      overflow: auto;
      background: url("../../assets/img/life.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng2{
      overflow: auto;
      background: url("../../assets/img/biology.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng3{
      overflow: auto;
      background: url("../../assets/img/gene.jpg") no-repeat;
      background-size:auto;
    }
    //鼠标移入后
    .xingcheng1:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/life1.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng2:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/biology1.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng3:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/gene1.jpg") no-repeat;
      background-size:auto;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .cons .xing_1{
      display: block!important;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .cons .xing_1 li {
      margin-bottom: 10px;
      width: 320px !important;
      margin-right: 0 !important;
      height: 200px !important;
    }
    .cons .xing_1 li .img {
      width: 70px !important;
    }
    .cons .xing_1 li:last-child {
      margin-bottom: 0;
    }
    .cons .xing_1 li .img {
      padding-top: 35px !important;
      padding-bottom: 35px !important;
    }
    .cons .xing_1 .xingcheng1:hover{
      background: url("../../assets/img/life.jpg") no-repeat!important;
    }
    .cons .xing_1 .xingcheng2:hover{
      background: url("../../assets/img/biology.jpg") no-repeat!important;
    }
    .cons .xing_1 .xingcheng3:hover{
      background: url("../../assets/img/gene.jpg") no-repeat!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisible && !$route.meta.invisibles && !$route.meta.show">
      <!-- alt="擎科生物-合成基因组学产品及服务" -->
      <div class="con"><img src="@/assets/img/产品及服务/合成基因组学产品及服务/banner.jpg" class="img-fluid" alt="基因合成"></div>
      <div class="cons"><img src="@/assets/img/研究领域banner/合成基因组学产品及服务.jpg" class="img-fluid" alt="基因合成"></div>
      <div class="info"></div>
    </div>
<!--    &lt;!&ndash;-移动端&ndash;&gt;-->
<!--    <div class="cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">-->
<!--      <img src="@/assets/img/研究领域banner/合成基因组学产品及服务.jpg" class="img-fluid">-->
<!--      <div class="info"></div>-->
<!--    </div>-->
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles && !$route.meta.show">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc"><span style="font-weight:bold;">合成科学（Synthetic Science）</span>以化学的基本原理为指导，通过设计并发展实用工具实现可控的化学键活化、断裂和重组，并以适当的策略将相应的模式和工具进行整合，完成特定功能物质的合成。它是分子创制的核心和基础，包括化学合成（Chemical Synthesis）和生物合成（Biosynthesis）两种重要方式，与生命、健康、农业、材料和能源等领域密切关联。</p>
      <p class="desc">DNA合成是合成科学重要的基础技术，基因合成是合成科学的核心驱动力，推动科学和技术进步。化学合成DNA成本的降低和DNA片段组装方法的改进使得合成科学的规模扩大到产生整个染色体和基因组的水平。基因合成和引物合成技术的进步进一步加速了这一过程，同时病毒包装技术在基因传递和表达中的应用也发挥了重要作用。</p>
      </div>
      <div class="service">
        <div class="c-title">合成生物学研究领域 <small>Research field of synthetic biology</small></div>
        <div class="title-desc">合成科学是包容了化学合成、生物合成、合成生物学等不同方向的系统科学，在生命、健康、农业、材料和能源等领域发挥着重要的作用。在这些领域中，基因合成和引物合成技术尤为关键。通过这些技术，可以精准设计和构建新的生物功能，从而推动生物制造的创新与发展，提高各行业的效率和可持续性。</div>
        <div class="container con">
          <ul class="lists">
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/jiankang.png" alt="擎科生物-合成生物学研究领域
-医疗健康">
              <h4>医疗健康</h4>
              <p>疾病诊断、药物和疫苗开发等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/huaxue.png" alt="擎科生物-合成生物学研究领域-化学工业">
              <h4>化学工业</h4>
              <p>生物基化学品、生物能源等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/shiwu.png" alt="擎科生物-合成生物学研究领域-食品农业">
              <h4>食品农业</h4>
              <p>食品检测、作物遗传育种等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/jieneng.png" alt="擎科生物-合成生物学研究领域-节能环保">
              <h4>节能环保</h4>
              <p>环境监测、生物燃料等</p>
            </li>
          </ul>
        </div>
        <div class="container cons" style="margin-top: 20px;">
          <ul class="lists">
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/jiankang.png" alt="擎科生物-合成生物学研究领域
-医疗健康">
              <h4>医疗健康</h4>
              <p>疾病诊断、药物和疫苗开发等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/huaxue.png" alt="擎科生物-合成生物学研究领域-化学工业">
              <h4>化学工业</h4>
              <p>生物基化学品、生物能源等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/shiwu.png" alt="擎科生物-合成生物学研究领域-食品农业">
              <h4>食品农业</h4>
              <p>食品检测、作物遗传育种等</p>
            </li>
            <li>
              <img src="@/assets/img/产品及服务/合成基因组学产品及服务/jieneng.png" alt="擎科生物-合成生物学研究领域-节能环保">
              <h4>节能环保</h4>
              <p>环境监测、生物燃料等</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
      <div class="c-title">产品及服务<small>Products and services</small></div>
      <div class="title-desc">擎科生物形成了完整的基因合成产业链服务体系，专注于为客户提供合成基因组学产品及服务。业务涵盖基因合成、寡核苷酸合成及修饰、基因检测、化学合成原材料、合成仪器设备、生物试剂等，可为您提供全面专业的解决方案。</div>
        <div class="con">
          <ul class=" service_chan effect-lists">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/fenzi1_${item.img}${currentType===index ? '' : '_active'}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class=" service_chan ">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <div class="gene_img2">
                <img :src="`/static/img/fenzi1_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 55px;height: 55px;">
              </div>
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>

      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="con">
            <div class="neirong" style="display: flex">
              <div class="left ">
                <img style="width: 310px" src="@/assets/img/产品及服务/合成基因组学产品及服务/bg2.png" class="img-fluid" alt="
擎科生物-合成基因组学产品及服务优势-基因合成全产业链平台、拥有Sanger测序平台、全新引进Fast NGS技术、基因功能工具研究平台、分子生物学实验研发平台、强大的服务网络体系，全天候24h提供优质完善的售前售后服务
">
              </div>
              <div class="right">
                <div class="required">
                  <p class="mb20">1.全产业链优势：集合成原材料、合成用仪器设备、合成技术及服务为一体，拥有每年6亿碱基的合成能力。</p>
                  <p class="mb20">2.合成优势：基因合成方面，擎科掌握酵母组装多片段，可智能化合成300 bp~5 kb长度、大片段核心技术关键点，可生产200 kb大片段基因。Oligo合成方面，擎科旗下子公司梓熙生物拥有ISO 13485认证，采用国际先进的合成技术，高质量的合成试剂，先进的自动化生产设备，完善的修饰类型，为客户提供μg~kg级别的各类Oligo合成服务。</p>
                  <p class="mb20">3.检测优势：拥有精准的基因检测平台，Sanger测序、Fast NGS测序，NGS测序加速合成基因组学研究。Sanger测序是DNA测序的金标准，Fast NGS测序无需引物即可准确分析1 kb以上的长片段，适用于PCR产物测序、菌液测序、质粒测序、编辑效率测序，NGS测序满足人源、动物、植物、微生物等多物种不同样本的基因组测序、转录组测序要求。</p>
                  <p class="mb20">4.已经建立基因编辑、病毒包装、甲基化检测等完善的基因功能工具研究平台，致力于为基因治疗领域提供专业、全面、一站式解决方案。</p>
                  <p class="mb20">5.设立全方位分子生物学实验研发平台，可提供个性化的常规分子生物学服务，及时交付精准的实验结果和实验报告，帮助解决科研难题。</p>
                  <p>6.强大的服务网络体系，全国设有本地化实验室，可及时收取客户样品，快速交付结果。已于天津建立全国大数据客服中心，全天候24h提供优质完善的售前售后服务。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cons">
            <div class="neirong" style="display: flex">
              <div class="right">
                <div class="required">
                  <p class="mb20">1.全产业链优势：集合成原材料、合成用仪器设备、合成技术及服务为一体，拥有每年6亿碱基的合成能力。</p>
                  <p class="mb20">2.合成优势：基因合成方面，擎科掌握酵母组装多片段，可智能化合成300 bp~5 kb长度、大片段核心技术关键点，可生产200 kb大片段基因。Oligo合成方面，擎科旗下子公司梓熙生物拥有ISO 13485认证，采用国际先进的合成技术，高质量的合成试剂，先进的自动化生产设备，完善的修饰类型，为客户提供μg~kg级别的各类Oligo合成服务。</p>
                  <p class="mb20">3.检测优势：拥有精准的基因检测平台，Sanger测序、Fast NGS测序，NGS测序加速合成基因组学研究。Sanger测序是DNA测序的金标准，Fast NGS测序无需引物即可准确分析1 kb以上的长片段，适用于PCR产物测序、菌液测序、质粒测序、编辑效率测序，NGS测序满足人源、动物、植物、微生物等多物种不同样本的基因组测序、转录组测序要求。</p>
                  <p class="mb20">4.已经建立基因编辑、病毒包装、甲基化检测等完善的基因功能工具研究平台，致力于为基因治疗领域提供专业、全面、一站式解决方案。</p>
                  <p class="mb20">5.设立全方位分子生物学实验研发平台，可提供个性化的常规分子生物学服务，及时交付精准的实验结果和实验报告，帮助解决科研难题。</p>
                  <p>6.强大的服务网络体系，全国设有本地化实验室，可及时收取客户样品，快速交付结果。已于天津建立全国大数据客服中心，全天候24h提供优质完善的售前售后服务。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <div class="c-title">相关研究领域<small>Related research fields</small></div>
        <div class="con">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-合成基因组学产品及服务
"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生命科学研究设备及原料
"></div>
              <p>生物制造CXO</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-生物制造CXO
"></div>
              <p>合成基因组学产品及服务</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
              <p>生物制造CXO</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-生物制造CXO"></div>
              <p>合成基因组学产品及服务</p>
            </li>
          </ul>
        </div>

      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
        <!-- <qk-consult type="Virus"/> -->
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'DNA提取', img: '1', ref: ''},
        {name: 'PCR扩增', img: '2', ref: ''},
        {name: '提取+扩增+测序', img: '3', ref: ''},
        {name: 'SSR/STR检测', img: '4', ref: ''},
        {name: 'SNP检测', img: '5', ref: ''},
        {name: '特定基因检测', img: '6', ref: ''},
        {name: '荧光定量PCR', img: '7', ref: ''},
        {name: '菌种鉴定', img: '8', ref: ''},
        {name: '细胞系鉴定', img: '9', ref: ''},
        {name: 'T载体构建', img: '10', ref: ''},
        ],
      gene1: [
        {name: '引物合成',img: '1', ref: '/tec/compose'},
        {name: '基因合成', img: '2',ref: '/tec/gen_compose'},
        {name: '基因检测',img: '3', ref: '/products/Gene'},
        {name: '基因功能',img: '4', ref: '/products/Gene_regulation'},
        {name: '病毒包装',img: '5', ref: '/Virus/Virus_packaging'},
        {name: '常规分子项目' ,img: '7',ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Products1.vue